import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { ThemeProvider } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/pt-br';
import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';

import RoutersApp from './routes';
import theme from './themes';

function App() {
  const client = new ApolloClient({
    // eslint-disable-next-line no-undef
    uri: `${process.env.REACT_APP_BACKEND_SERVER_URL}/graphql` || 'http://localhost:8080/graphql',
    cache: new InMemoryCache(),
  });

  useEffect(() => {
    const link = document.querySelector('link[rel="icon"]');
    if (link) {
      link.setAttribute('href', 'favicon-ps.ico');
    }
  }, []);
  return (
    <BrowserRouter>
      <ApolloProvider client={client}>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='pt-br'>
            <CssBaseline />
            <RoutersApp />
          </LocalizationProvider>
        </ThemeProvider>
      </ApolloProvider>
    </BrowserRouter>
  );
}

export default App;
